import React from "react";
import SingleContentPage from "../Shared/SingleContentPage";

const MenuList = () => {
  return <SingleContentPage title="Menu Manager" moduleKey="menu-manager" />;
};

export default MenuList;
